import React, { useEffect, useState } from "react";
import { API, Hub, I18n } from "aws-amplify";
import { translations } from "@aws-amplify/ui";
import { Authenticator } from "@aws-amplify/ui-react";
import "@aws-amplify/ui-react/styles.css";
import {
    Alert,
    Button,
    Col,
    Divider,
    notification,
    Popconfirm,
    Radio,
    Row,
    Space,
    Spin,
    Typography,
} from "antd";
import {
    DeleteOutlined,
    DownloadOutlined,
    LogoutOutlined,
} from "@ant-design/icons";
import "./App.css";
import { Buffer } from "buffer";

import Config from "./Config.js";
import Reason from "./Reason.js";
import StartGroup from "./StartGroup.js";
import StartList from "./StartList.js";
import UserConfig from "./UserConfig";

const { Paragraph, Title } = Typography;

const dict = {
    de: {
        "Creating Account": "Account wird erstellt...",
        "Confirm Password": "Passwort bestätigen",
        "We Emailed You": "E-Mail mit Bestätigungscode ist unterwegs",
        "We Sent A Code": "Es wurde ein Bestätigungscode versandt",
        Confirming: "Bestätigung läuft...",
        "Enter your code": "Bestätigungscode eingeben",
        "Enter your email": "E-Mail-Adresse eingeben",
        "Send code": "Bestätigungscode senden",
        "Resend Code": "Bestätigungscode erneut senden",
        Code: "Bestätigungscode",
        "New password": "Neues Passwort",
        "User does not exist.": "Benutzer unbekannt.",
        "Your passwords must match": "Die Passwörter müssen übereinstimmen",
        "Password did not conform with policy: Password not long enough":
            "Passwort nicht lang genug",
        "Incorrect username or password.": "Benutzername oder Passwort falsch.",
        "Signing in": "Einloggen...",
    },
};

I18n.putVocabularies(translations);
I18n.putVocabularies(dict);
I18n.setLanguage("de");

const initialConfig = {
    title: "Titel",
    type: "",
};

function App() {
    //console.log(translations);
    //console.log(I18n.get('We emailed you'));

    //console.log("App()");

    const [config, setConfig] = useState(initialConfig);
    const [startGroups, setStartGroups] = useState([]);
    const [participants, setParticipants] = useState([]);
    const [users, setUsers] = useState([]);
    const [loading, setLoading] = useState(false);
    const [isAdmin, setAdmin] = useState(false);
    const [error, setError] = useState();
    const [association, setAssociation] = useState("");
    const [participation, setParticipation] = useState("yes");
    const [reason, setReason] = useState("");
    const [allParticipants, setAllParticipants] = useState([]);
    const [env, setEnv] = useState({});
    const [showAlert, setShowAlert] = useState(false);
    const [enableStartlist, setEnableStartlist] = useState(false);
    const [alertConfirmed, setAlertConfirmed] = useState(false);

    const handleHubEvents = (data) => {
        //console.log("hub event:", data);
        if (data.payload.event === "signIn") {
            //console.log("sign in");
            setAlertConfirmed(false);
            setLoading(true);
            getData();
        }
        if (data.payload.event === "signOut") {
            //console.log("sign out");
        }
    };

    useEffect(() => {
        //console.log("useEffect");

        Hub.listen("auth", handleHubEvents);

        return () => {
            Hub.remove("auth", handleHubEvents);
        };
    });

    function clearStates() {
        setConfig(initialConfig);
        setStartGroups([]);
        setParticipants([]);
        setUsers([]);
        setLoading(true);
        setAdmin(false);
        setError();
        setAssociation("");
        setParticipation("yes");
        setReason("");
        setAllParticipants([]);
        setEnv({});
        setShowAlert(false);
        setEnableStartlist(false);
    }

    function setStates(data) {
        setLoading(false);
        if (data.isAdmin === true) {
            setShowAlert(false);
            setAdmin(true);
            // GDD2024: override name of Jugendgruppe
            // >>>
            const tempAllParticipants = data.allParticipants.map((value) => {
                if (
                    value.startGroup === 21 &&
                    value.lastName === "Hebertsfelden"
                ) {
                    //value.association = "verschiedene";
                    value.lastName = "Gemischte Jugendgruppe";
                }
                return value;
            });
            console.log("allParticipants", data.allParticipants);
            console.log("tempAllParticipants", tempAllParticipants);
            // <<<
            setAllParticipants(data.allParticipants);
        } else {
            setShowAlert(true);
            setAdmin(false);
            setAllParticipants([]);
        }
        if (data.enableStartlist === true) {
            setEnableStartlist(true);
        } else {
            setEnableStartlist(false);
        }
        setConfig({
            title: data.title,
            type: data.type,
            mode: data.mode,
        });
        //setStartGroups(data.startGroups);
        // workaround for GDD (no AK7/8 and AK6 --> über 24 Jahre)
        setStartGroups(
            data.startGroups.reduce((prev, cur) => {
                if (cur.id != 7 && cur.id != 8) {
                    if (cur.id == 6) {
                        cur.name =
                            "Altersklasse 6 (über 24 Jahre; Jahrg. ab 2002)";
                    }
                    prev.push(cur);
                }
                return prev;
            }, []),
        );
        setUsers(data.users);
        if (data.association) {
            setAssociation(data.association);
            setParticipants(data.participants);
            let participation = "yes";
            let reason = "";
            if (data.notParticipating) {
                for (let i = 0; i < data.notParticipating.length; i++) {
                    //console.log(data.notParticipating[i]);
                    if (
                        data.notParticipating[i].association ===
                        data.association
                    ) {
                        //console.log("hit");
                        participation = "no";
                        reason = data.notParticipating[i].reason;
                    }
                }
            }
            setParticipation(participation);
            setReason(reason);
            /*
      if (data.notParticipating &&
        data.notParticipating[0] &&
        (data.notParticipating[0].association === data.association)) {
        setParticipation("no");
        setReason(data.notParticipating[0].reason);
      }
      else {
        setParticipation("yes");
        setReason("");
      }
      */
        } else {
            setAssociation("");
            setParticipants([]);
        }
        if (data.env) {
            //console.log(data.env);
            setEnv(data.env);
        }
    }

    async function downloadCSV(format) {
        /*
    const str = "AÄA";
    console.log(Buffer.from(str));
    console.log(Buffer.from(str, "latin1"));
    */

        const data = await API.get("ddppanm0a", "/csv/" + format);
        //console.log(data);
        const encodedData = Buffer.from(data.toString(), "latin1");
        //const blob = new Blob([encodedData], { type: "application/octet-binary" });
        const blob = new Blob([encodedData], { type: "text/csv" });
        const a = document.createElement("a");
        a.style = "display:none";
        //a.href = "data:text/csv;charset=utf-8," + encodeURIComponent(data);
        a.href = window.URL.createObjectURL(blob);
        if (format === "part") {
            a.download = "Anmeldungen.csv";
        }
        if (format === "overview") {
            a.download = "Vereine.csv";
        }
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
    }

    async function getData() {
        const data = await API.get("ddppanm0a", "/data");
        //console.log("getData", data);
        if (data.error) {
            setLoading(false);
            setError(<Alert message={data.error} type="error" />);
        } else {
            setStates(data);
        }

        return null;
    }

    const saveConfig = async (values) => {
        setLoading(true);
        const newConfig = {
            mode: values.mode,
            title: values.title,
            type: values.type,
        };
        setConfig(newConfig);
        const data = await API.put("ddppanm0a", "/conf", { body: newConfig });
        if (data.error) {
            // TODO: error handling
        } else {
            setStates(data);
        }
    };

    const addParticipant = async (startGroup, values) => {
        //console.log(values);
        if (!association) {
            console.log("ERROR: no association");
            let adminText = "";
            if (isAdmin) {
                adminText = (
                    <p>Bitte im Admin-Bereich einen Vorplattler selektieren.</p>
                );
            }
            notification.error({
                message: "Anmeldung fehlgeschlagen!",
                description: (
                    <>
                        <p>Ungültiger Verein.</p>
                        {adminText}
                    </>
                ),
                duration: 0,
            });
        } else {
            await addParticipant_impl(association, startGroup, values);
        }
    };

    const addParticipant_impl = async (association, startGroup, values) => {
        //console.log(values);
        const d = new Date();
        let id = startGroup === 0 ? 0 : d.toISOString();
        let newParticipant = {
            id: id,
            startGroup: startGroup,
            association: association
                ? association.substring(0, 64)
                : association,
        };
        if (values) {
            newParticipant.firstName = values.firstName
                ? values.firstName.substring(0, 64)
                : values.firstName;
            newParticipant.lastName = values.lastName
                ? values.lastName.substring(0, 64)
                : values.lastName;
            newParticipant.reason = values.reason
                ? values.reason.substring(0, 2048)
                : values.reason;
        }
        const data = await API.put("ddppanm0a", "/part", {
            body: newParticipant,
        });
        //console.log(data);
        if (data.error) {
            // TODO: error handling
        } else {
            setStates(data);
        }
    };

    const addUser = async (values) => {
        const d = new Date();
        const newUser = {
            id: d.toISOString(),
            email: values.email ? values.email.substring(0, 64) : values.email,
            association: values.association
                ? values.association.substring(0, 64)
                : values.association,
        };
        const data = await API.put("ddppanm0a", "/usr", { body: newUser });
        if (data.error) {
            // TODO: error handling
        } else {
            setStates(data);
        }
    };

    const changeParticipation = async (event) => {
        setParticipation(event.target.value);
        if (event.target.value === "yes") {
            setLoading(true);
            await deleteParticipant(0, 0);
            setLoading(false);
        } else {
            setLoading(true);
            await addParticipant(0, {});
            setLoading(false);
            //setReasonButton(reasonButtonStates.changed);
        }
    };

    const deleteAll = async () => {
        setLoading(true);
        const data = await API.del("ddppanm0a", "/part", {
            body: { all: "*" },
        });
        setLoading(false);
        //console.log(data);
        if (data.error) {
            console.log(data.error.message);
        } else {
            setStates(data);
        }
    };

    const deleteParticipant = async (id, startGroup) => {
        if (!association) {
            console.log("ERROR: no association");
        }
        const delParticipant = {
            id: id,
            startGroup: startGroup,
            association: association,
        };
        const data = await API.del("ddppanm0a", "/part", {
            body: delParticipant,
        });
        if (data.error) {
            // TODO: error handling
        } else {
            setStates(data);
        }
    };

    const deleteUser = async (id) => {
        const data = await API.del(
            "ddppanm0a",
            "/usr/" + id /*, {body: 'test body'}*/,
        );
        if (data.error) {
            // TODO: error handling
        } else {
            setStates(data);
        }
    };

    const saveReason = async (reason) => {
        await addParticipant(0, { reason: reason });
    };

    const selectUser = async (association) => {
        setLoading(true);
        //console.log(association);
        const data = await API.post("ddppanm0a", "/part", {
            body: { association: association },
        });
        //console.log(data);
        if (data.error) {
            // TODO: error handling
        } else {
            setStates(data);
        }
    };

    const uploadTestData = async (testData) => {
        setLoading(true);
        //console.log(testData);
        const data = await API.put("ddppanm0a", "/testdata", {
            body: { testData: testData },
        });
        //console.log(data);
        data.association = "";
        setStates(data);
        setLoading(false);
    };

    function renderRegisterForm() {
        if (error) {
            return error;
        } else if (
            config.mode === "readonly" ||
            config.mode === "active" ||
            isAdmin === true
        ) {
            return (
                <>
                    <Row>
                        <Col offset={2}>
                            <Title level={2}>{config.title}</Title>
                        </Col>
                    </Row>
                    <Row>
                        <Col offset={2}>
                            <Title level={3}>Verein: {association}</Title>
                        </Col>
                    </Row>
                    <Row>
                        <Col offset={2} span={20}>
                            <Divider>
                                <Radio.Group
                                    defaultValue="yes"
                                    disabled={
                                        config.mode === "readonly" &&
                                        isAdmin === false
                                    }
                                    optionType="button"
                                    buttonStyle="solid"
                                    onChange={changeParticipation}
                                    value={participation}
                                >
                                    <Radio.Button value="yes">
                                        Wir nehmen teil
                                    </Radio.Button>
                                    <Radio.Button value="no">
                                        Wir nehmen nicht teil
                                    </Radio.Button>
                                </Radio.Group>
                            </Divider>
                        </Col>
                    </Row>
                    {participation === "no" ? (
                        <Reason
                            disabled={
                                config.mode === "readonly" && isAdmin === false
                            }
                            reason={reason}
                            saveReason={saveReason}
                        />
                    ) : (
                        startGroups.map((startGroup, index) => {
                            return (
                                <StartGroup
                                    key={index}
                                    startGroup={startGroup}
                                    participants={participants}
                                    onAdd={addParticipant}
                                    onDelete={deleteParticipant}
                                    readonly={
                                        config.mode === "readonly" &&
                                        isAdmin === false
                                    }
                                />
                            );
                        })
                    )}
                </>
            );
        } else {
            return loading ? (
                <></>
            ) : (
                <Alert
                    type="info"
                    showIcon={true}
                    closable={false}
                    message="Derzeit sind keine Anmeldungen möglich."
                    style={{ marginBottom: 10, marginTop: 10 }}
                />
            );
        }
    }

    function renderAdmin() {
        //console.log(config);
        if (isAdmin) {
            return (
                <>
                    <Divider />
                    <Row style={{ textAlign: "center" }}>
                        <Col span={24}>
                            <Title level={2}>Admin-Bereich</Title>
                        </Col>
                    </Row>
                    <Config
                        onSave={saveConfig}
                        title={config.title}
                        type={config.type}
                        mode={config.mode}
                    />
                    <UserConfig
                        users={users}
                        onAdd={addUser}
                        onDelete={deleteUser}
                        onSelect={selectUser}
                    />
                    <Divider>
                        <Title level={3}>Allgemein</Title>
                    </Divider>
                    <Row style={{ textAlign: "center" }}>
                        <Col span={24}>
                            <Space>
                                <Button
                                    icon={<DownloadOutlined />}
                                    onClick={() => {
                                        downloadCSV("part");
                                    }}
                                >
                                    Anmeldungen herunterladen (CSV)
                                </Button>
                                <Button
                                    icon={<DownloadOutlined />}
                                    onClick={() => {
                                        downloadCSV("overview");
                                    }}
                                >
                                    Vereinsübersicht herunterladen (CSV)
                                </Button>
                                <Popconfirm
                                    title="Wirklich alle Anmeldungen löschen?"
                                    okText="Ja"
                                    cancelText="Nein"
                                    okButtonProps={{ type: "danger" }}
                                    onConfirm={deleteAll}
                                >
                                    <Button
                                        type="danger"
                                        icon={<DeleteOutlined />}
                                    >
                                        Anmeldungen löschen
                                    </Button>
                                </Popconfirm>
                            </Space>
                        </Col>
                    </Row>
                    {enableStartlist ? (
                        <StartList
                            allParticipants={allParticipants}
                            env={env}
                            startGroups={startGroups}
                            users={users}
                            uploadTestData={uploadTestData}
                        />
                    ) : null}
                </>
            );
        } else {
            return null;
        }
    }

    function signOutHandler(signOut) {
        clearStates();
        signOut();
    }

    return (
        <Authenticator loginMechanisms={["email"]} signUpAttributes={["email"]}>
            {({ signOut, user }) => {
                window.onload = () => {
                    // force reload of data if user has clicked the refresh button of the browser
                    //console.log("onload", signedIn);
                    setAlertConfirmed(false);
                    //setShowAlert(true);
                    setLoading(true);
                    getData();
                };
                //console.log(user);
                return (
                    <div className="App">
                        <Row style={{ textAlign: "center", marginBottom: 20 }}>
                            <Col offset={10} span={4}>
                                <Button
                                    type="danger"
                                    icon={<LogoutOutlined />}
                                    onClick={() => signOutHandler(signOut)}
                                >
                                    Ausloggen
                                </Button>
                            </Col>
                        </Row>
                        {showAlert && !alertConfirmed ? (
                            <Alert
                                description={
                                    <>
                                        <Title level={4}>
                                            Hinweis zum Datenschutz
                                        </Title>
                                        <Paragraph>
                                            Die personenbezogenen Daten der
                                            Teilnehmer (Name, Verein,
                                            Altersklasse etc.) werden vom
                                            Bayerischen Inngau-Trachtenverband
                                            verwendet und veröffentlicht
                                            (Startliste, Ergebnisliste, Presse
                                            etc.).
                                        </Paragraph>
                                        <Paragraph>
                                            Sollte ein Teilnehmer mit dieser
                                            Verwendung bzw. Veröffentlichung
                                            nicht einverstanden sein, so ist
                                            dessen Name mit einem * zu
                                            kennzeichnen.
                                        </Paragraph>
                                        <Title level={4}>
                                            Richtigkeit der Angaben
                                        </Title>
                                        <Paragraph>
                                            Die Altersklasseneinteilung ist für
                                            alle Teilnehmer jahrgangsmäßig
                                            bindend. Der Vorplattler (bzw.
                                            Jugendleiter bei Jugend und Kindern)
                                            des teilnehmenden Vereins bestätigt
                                            hiermit die Richtigkeit der
                                            Altersangaben.
                                        </Paragraph>
                                        <Paragraph>
                                            Falsche Meldungen in den
                                            Altersklassen führen zur
                                            Disqualifikation des jeweiligen
                                            Teilnehmers oder der Gruppe.
                                        </Paragraph>
                                        <Paragraph>
                                            Ausnahmen müssen vorab mit dem 1.
                                            Gauvorplattler abgestimmt werden.
                                        </Paragraph>
                                        <Button
                                            type="primary"
                                            onClick={() =>
                                                setAlertConfirmed(true)
                                            }
                                        >
                                            Einverstanden und weiter zur
                                            Anmeldung...
                                        </Button>
                                    </>
                                }
                                showIcon
                            />
                        ) : (
                            <Spin spinning={loading}>
                                {renderRegisterForm()}
                                {renderAdmin()}
                            </Spin>
                        )}
                    </div>
                );
            }}
        </Authenticator>
    );
}

export default App;
